import { BusinessCardFields } from "../../types/request.types";

import classes from "./Request.module.css";

interface BusinessCardProps {
  request: BusinessCardFields;
}

const BusinessCard = ({ request }: BusinessCardProps) => (
  <dl className={classes.details}>
    <dt>Name</dt>
    <dd>{request.name}</dd>
    <dt>Title</dt>
    <dd>{request.title}</dd>
    <dt>Campus</dt>
    <dd>{request.campus}</dd>
    <dt>Phone</dt>
    <dd>{request.phone}</dd>
    <dt>Mobile</dt>
    <dd>{request.mobile}</dd>
    <dt>Fax</dt>
    <dd>{request.fax}</dd>
    <dt>Email</dt>
    <dd>{request.email}</dd>
    <dt>Amount</dt>
    <dd>{request.amount}</dd>
  </dl>
);

export default BusinessCard;
